// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-area[data-v-798e296b]{padding-top:1%;display:flex}.search-area__input[data-v-798e296b]{max-width:50%}", ""]);
// Exports
module.exports = exports;
